import { Link } from "react-router-dom";
import ServiceIcon from "@/components/ServiceIcons";
import Reveal from "@/components/Reveal";
import { lines, sz, txt, useContent } from "@/content/ContentContext";
import networkGraphic from "@/assets/network.png";

const WhatWeDo = () => {
  const c = useContent();
  const w = c.home.whatwedo;

  return (
    <section className="whatwedo" id="services">
      <img
        src={networkGraphic}
        alt=""
        className="wwd-network"
        aria-hidden="true"
      />
      <div className="wwd-inner">
        <Reveal className="wwd-left" y={22}>
          <h2 className="section-title" style={sz(w.title1)}>
            {lines(w.title1)}{" "}
            <span className="text-green" style={sz(w.accent)}>
              {txt(w.accent)}
            </span>
          </h2>
          <p className="section-para" style={sz(w.paragraph)}>
            {lines(w.paragraph)}
          </p>
        </Reveal>

        <div className="wwd-cards">
          {w.cards.map((card, index) => (
            <Reveal
              as="article"
              key={card.slug || index}
              className={
                index === 1 ? "svc-card svc-card-highlight" : "svc-card"
              }
              delay={index * 0.12}
              y={28}
              data-testid={`umbrella-card-${card.slug || index}`}
            >
              <div className="svc-icon">
                <ServiceIcon name={card.icon} />
              </div>
              <h3 className="svc-title" style={sz(card.title)}>
                {lines(card.title)}
              </h3>
              <p className="svc-body" style={sz(card.body)}>
                {lines(card.body)}
              </p>
              <Link
                to={`/services#${card.slug}`}
                className="svc-link"
                style={sz(w.learnMoreLabel)}
                data-testid={`learn-more-${index + 1}`}
              >
                {txt(w.learnMoreLabel)}
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
